import { WalletMockService } from "@/services/backend";
import { Button } from "@mantine/core";
import { CheckoutRequest } from "..";
import { randomUUID } from "crypto";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { base64EncodeUrl, bufferToBase64 } from "@/lib/encoding";

export function TestCheckoutPage() {
    const navigate = useNavigate();
    async function goToCheckout() {
        const request: CheckoutRequest = {
            merchant: "bestbuy.com",
            preid: "testproductid1",
            subtotal: "79.99",
            shipping: "0.00",
            tax: "0.00",
            total: "79.99",
            desc: "test product",
            callback: "",
            cid: "",
            productUrl: "https://www.bestbuy.com/product/jlab-jbuds-lux-anc-headphones-graphite/J3GW8XZR73/sku/6580402",
            //items: [{id: "6580398", amount:"79.99", name:"Jlab lux headphones", url:"", quantity:1, merchant: "bestbuy.com"}, {id:"6616036",amount:"69.99", name:"Seagate - Barracuda 4TB Internal Hard Drive for Desktops", quantity: 1, url:"https://www.bestbuy.com/product/seagate-barracuda-4tb-internal-hard-drive-for-desktops/J37C5HK32Z/sku/6616037", merchant:"bestbuy.com"}]
            items: [{ id: "6580398", amount: "79.99", name: "Jlab lux headphones", url: "", quantity: 1, merchant: "bestbuy.com" }]
        }
        const id = await WalletMockService.checkout(request);
        navigate(`/checkout/${id}`);
    }

    const [cp, setCP] = useState("");

    // useEffect(() => {
    //     //printPK()
    // }, [])

    // async function printPK() {
    //     let data = "";
    //     /*
    //     if(window.PublicKeyCredential && PublicKeyCredential.getClientCapabilities){
    //         const cpo = await PublicKeyCredential.getClientCapabilities()
    //         data = data.concat(JSON.stringify(cpo, null, "\n"))
    //     }*/
    //     if(window.PublicKeyCredential && window.PublicKeyCredential.isConditionalMediationAvailable){
    //         const conditional = await PublicKeyCredential.isConditionalMediationAvailable()
    //         data = data.concat("conditional : "+conditional)
    //     }
    //     setCP(data)
    // }

    /* 
    async function testPRF() {
        const r : PublicKeyCredential | null = await navigator.credentials.get({
            publicKey: {
                timeout: 60000,
                challenge: new Uint8Array([
                    // must be a cryptographically random number sent from a server. Don't use dummy
                    // values in real authentication situations.
                    1, 2, 3, 4,
                ]).buffer,
                extensions: { prf: { eval: { first: new TextEncoder().encode("loginid-key") } } },
            },
        })

        setCP(bufferToBase64(r.getClientExtensionResults().prf?.results?.first))
    }

    async function createPRF() {
        const r : PublicKeyCredential | null = await navigator.credentials.create({
            publicKey: {
                rp: { name: "Acme" },
                user: {
                    id: new Uint8Array(16),
                    name: "john.p.smith@example.com",
                    displayName: "John P. Smith"
                },
                pubKeyCredParams: [
                    {
                        "type": "public-key",
                        "alg": -8
                    },
                    {
                        "type": "public-key",
                        "alg": -7
                    },
                    {
                        "type": "public-key",
                        "alg": -257
                    }
                ],
                timeout: 60000,
                authenticatorSelection: {
                    residentKey: "required",
                },
                extensions: { prf: { eval: { first: new TextEncoder().encode('loginid-key') } } },

                // unused without attestation so a dummy value is fine.
                challenge: new Uint8Array([0]).buffer,
            }
        })

        setCP(bufferToBase64(r.getClientExtensionResults().prf?.results?.first))
    }
*/

    return (
        <>
            <Button onClick={goToCheckout}>Go To Checkout</Button>
            {/* 
            <Button onClick={testPRF}>Test PRF</Button>
            <Button onClick={createPRF}>Create PRF</Button>
            */}
            <p>
                {cp}
            </p>
        </>
    )
}